<template>
  <v-container style="width: 800px;">   

    <div style="height: 55px;"></div>
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          {{ $t('title.admin-nondisplay-items') }}
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="shopsItems"
          class="elevation-1"
          :customFilter="customFilter"
          :search="multipleSearchObj"
          hide-actions
        >          
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <tr              
              v-bind:class="{
                'deleted-class-name': props.item.isDeleted == '1' ? true : false               
              }"
            >              
              <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
              <td class="text-xs-left">{{ props.item.itemName }}</td>
              <td class="text-xs-left">{{ props.item.janCode }}</td>
            </tr>
          </template>
        </v-data-table>
        <br />

        <!-- 버튼 영역 -->
        <div class="footer-btns">
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/display-store-items-list2' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
          <v-btn block class="ma-2" color="success" @click="forwardStoreItemDisplayRegist()" >
            <v-icon dark left>save</v-icon>非表示に登録する
          </v-btn>
          <v-btn block class="ma-2" color="red" @click="forwardStoreItemDisplayDelete()" >
            <v-icon dark left>save</v-icon>表示のため削除する
          </v-btn>               
        </div>
      </v-container>
    </v-card>   
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    this.storeCode = this.$route.params.storeCode
    ServerApiCallService.suppliersByStatus()
      .then(response => {
        this.suppliers = response.data.suppliers
        this.suppliers.unshift({
          supplierCode: '#',
          supplierName: '選択してください'
        })
        // 初期表示時の
        this.loading = false // 初期表示時の TODO
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
      
    // getItem on udpate
    let storesRequest = { storeCode: this.storeCode }
    ServerApiCallService.store(storesRequest)
      .then(response => {
        
        this.storeCode = response.data.store.storeCode
        this.storeName = response.data.store.storeName
        this.selectSupplier = {
          supplierCode: response.data.store.supplierCode
        }
        this.brands = this.changedSupplier(
          this.selectSupplier.supplierCode
        )
        this.selectBrand = {
          brandId: response.data.store.brandId
        }

        // 初期表示時の
        this.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })  
    
    ServerApiCallService.nonDisplayStoreItems(storesRequest)
      .then(response => {
        this.shopsItems = response.data.items
        
        this.shopsItems.forEach(function(val) {
          // 表示する商品IDをdispShopsItemsIDsに保持する
          this.dispShopsItemsIDs.push(val.itemCode)
        })

        this.handlingItemsByStore = response.data.stores
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    changedSupplier(supplierCode) {
      let thisObj = this

      let request = {
        supplierCode: supplierCode
      }

      ServerApiCallService.brandsBySupplierCode(request)
        .then(response => {
          
          thisObj.brands = response.data.brands
          thisObj.brands.unshift({
            brandId: '#',
            brandName: '選択してください'
          })
          // 初期表示時の
          thisObj.loading = false // 初期表示時の TODO
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      // 선택된 조건(카테고리 / 取扱商品のみ)에 맞게 테이블에 표시할 상품을 필터링
      let filterlingItems = items.filter(
        item =>
          (search.itemCategoryId === '#' ||
            item.itemCategoryId === search.itemCategoryId) &&
          (!search.dispOnlyHandling ||
            (search.dispOnlyHandling && item.isHandling))
      )

      // 현재 shopsItems에서 isHandling == true 인 상품만 dispShopsItemsIDs에 유지
      // → 카테고리 바꾸거나 검색을 바꿔도 선택된 상품이 절대로 사라지지 않도록 보존
      this.dispShopsItemsIDs = this.shopsItems
      .filter(i => i.isHandling)             // 체크된 상품만 유지
      .map(i => i.itemCode);

      return filterlingItems
    },    
    // 상품 일괄 등록 버튼을 클릭헸을때
    forwardStoreItemDisplayRegist() {
      // 선택한 점포를 sesseion에 등록
      let storeCode = this.storeCode
      let storeName = this.storeName
      let supplierCode = this.selectSupplier.supplierCode
      this.selectedStores.push({storeCode, storeName, supplierCode});

      sessionStorage.setItem("param", JSON.stringify(this.selectedStores));
      // 등록 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-regist2'})
    },
    // 상품 일괄 삭제 버튼을 클릭헸을때
    forwardStoreItemDisplayDelete() {

      if (!this.shopsItems || this.shopsItems.length === 0) {
        this.$parent.$parent.$parent.showErrorDialog('削除する商品がありません');
        return;
      }

      let storeCode = this.storeCode
      let storeName = this.storeName
      let supplierCode = this.selectSupplier.supplierCode
      this.selectedStores.push({storeCode, storeName, supplierCode});
      
      // 선택한 점포를 sesseion에 등록
      sessionStorage.setItem("param", JSON.stringify(this.selectedStores));
      // 삭제 페이지에 이동
      this.$router.push({name: 'admin-display-store-items-delete2'})
    },
  },
  data() {
    return {
      
      isHandling: true,
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,
      selected: [],
      storeCode: this.$route.params.storeCode,
      storeName: '',
      handlingItemsByStore: [],
      selectedStoreCode: '',
      suppliers: [],
      itemCategories: [],
      selectedStores: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て'
      },
      
      brands: [],
      selectBrand: {
        brandId: '#',
        brandName: '全て'
      },
      prefecture: '',

      // storeCode: this.$route.params.storeInfo.storeCode,
      // paramSupplierCode: this.$route.params.storeInfo.supplierCode,
      name: '',
      checkbox: null,


      handlingItem: false, // 취급상품 표시

      multipleSearchObj: {
        itemCategoryId: '#',
        dispOnlyHandling: false
      },

      headers: [
        {
          text: 'カテゴリ',
          align: 'left',
          sortable: false,
          value: 'categoryName',
          width: '200px',
          fixed: true
        },
        {
          text: '商品名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '300px',
          fixed: true
        },
        {
          text: 'JANコード',
          align: 'left',
          sortable: false,
          value: 'supplierCode',
          width: '100px'
        }
      ],
      shopsItems: [],
      dispShopsItemsIDs: []
    }
  }
}
</script>

<style>
.deleted-class-name {
  background-color: #b3b3b3;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
